export default {
      id: "pin-usage",
      viewBox: "0 0 18 23",
      url: __webpack_public_path__ + "img/icons.df848786.svg#pin",
      toString: function () {
        return this.url;
      }
    }